import t from "./ghl-ui.es1236.js";
import f from "./ghl-ui.es741.js";
import m from "./ghl-ui.es419.js";
import p from "./ghl-ui.es730.js";
var s = 1 / 0, i = t ? t.prototype : void 0, n = i ? i.toString : void 0;
function y(r) {
  if (typeof r == "string")
    return r;
  if (m(r))
    return f(r, y) + "";
  if (p(r))
    return n ? n.call(r) : "";
  var o = r + "";
  return o == "0" && 1 / r == -s ? "-0" : o;
}
export {
  y as default
};
